Pegasus.TemplateAppearanceSelectionView = Em.View.extend({
  classNames: ['template-appearance-selection'],
  classNameBindings: ['content', 'isActive:active', 'isFullScreen:full_screen'],
  isFullScreen: function(){
    return this.get('controller.selectedTemplateAppearance') === 'full_screen';
  }.property('controller.selectedTemplateAppearance'),
  isActive: function(){
    var selection = this.get('controller.selectedTemplateAppearance');

    if ( selection === 'full_screen' && (this.get('content') === 'centered') ) {
      return true;
    }

    return this.get('content') === this.get('controller.selectedTemplateAppearance');
  }.property('controller.selectedTemplateAppearance'),
  click: function(){
    var self = this.get('content');

    if ( self === 'empty' ) {
      return;
    }

    var selection = this.get('controller.selectedTemplateAppearance');
    if ( self === 'centered' && (selection === 'centered') ) {
      self = 'full_screen';
    }

    if ( selection === 'full_screen' && self === 'centered' ) {
      self = 'centered';
    }

    this.set('controller.selectedTemplateAppearance', self);
  },
  template: function(){
    return Em.Handlebars.compile('<div class="template-appearance-selection-content"><div class="tasc-icon"></div></div>');
  }.property()
});

Pegasus.TemplateAppearanceSelectorView = Em.View.extend({
  classNames: ['template-appearance-control'],
  template: function(){
    return Em.Handlebars.compile('{{view view.contentView}}');
  }.property(),
  contentView: Em.CollectionView.extend({
    content: ['empty', 'top_banner', 'empty', 'left_sidebar', 'centered', 'right_sidebar', 'empty', 'bottom_banner', 'empty'],
    itemViewClass: Pegasus.TemplateAppearanceSelectionView
  })
});
